import { OPEN_CHAT, CLOSE_CHAT } from '../constants/index';
import { ChatState, ChatActions } from '../types/chatTypes'

const initialState: ChatState = {
  isOpen: false,
  id: 0
}

const chatReducer = (state = initialState, action: ChatActions):ChatState => {
  const payload = action.payload
  switch(action.type){

    case OPEN_CHAT:
      return {
        ...state,
        isOpen: true,
        id: payload
      }

    case CLOSE_CHAT:
      return {
        ...state,
        isOpen: false,
        id: payload
      }
    
    default: 
      return state
  }
}

export default chatReducer;